module.exports = __webpack_public_path__ + "img/wxRode1.958d5344.jpg";